import { QTECode } from '~/core/constants';
import { DiagonalCornerOptions } from '~/core/enums';
import { CornerRadiusModel, DiagonalCornerModel } from '~/core/models';

export const getCornerType = (
  corner?: DiagonalCornerModel | CornerRadiusModel
): DiagonalCornerOptions => {
  if (corner?.name === DiagonalCornerOptions.REMOVE_DIAGONAL_CORNER) {
    return DiagonalCornerOptions.REMOVE_DIAGONAL_CORNER;
  }

  if (corner?.qteCodeId === QTECode.InsideCorner) {
    return DiagonalCornerOptions.INSIDE_CORNER;
  }

  return DiagonalCornerOptions.OUTSIDE_CORNER;
};
